module.exports = __webpack_public_path__ + "img/addWhite.81fa7c3d.svg";